import React from 'react'
import CustomizableProduct from '../CustomizableProduct/CustomizableProduct'

const SustainableProduct = () => {
    
    return (
        <>
            <CustomizableProduct />
        </>
    )
}

export default SustainableProduct